import './styles/default.scss';
import { type ProgressiveJackpotsResponseProps } from '@/lib/progressive-jackpots';
import { ValueTicker } from '../../../../elements/value-ticker/value-ticker';

type ProgressiveJackpotsBadgeProps = {
    jackpot: ProgressiveJackpotsResponseProps;
};

export const ProgressiveJackpotsBadge: React.FC<ProgressiveJackpotsBadgeProps> = ({ jackpot }) => {
    return (
        <div className="progressive-jackpot-badge">
            <ValueTicker prevAmount={jackpot.prevAmount} amount={jackpot.amount} />
        </div>
    );
};
